/* shah */
import React from 'react'
import WidgetToggleButton from './WidgetToggleButton'

const ProfileRow = (props) => {
    const { name, para, handle, classNameResp, arialabel, arialabelaria, arialabelpara, } = props;

    function eventTrigger(event) {
        if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
            handle();
        }
    }
    return (
        <div className={classNameResp}>
            <div
                className="WidgetAccessibilityProfileBoxContainerRow"
                aria-label={arialabel}
                onClick={eventTrigger}
                onKeyPress={eventTrigger}
                tabIndex={0}
                role="region"
            >
                <div className="WidgetAccessibilityProfileFlexColStart">
                    <h3 role="region" aria-label={arialabelaria}>{name}</h3>
                    <p role="region" aria-label={arialabelpara}>{para}</p>
                </div>
                <WidgetToggleButton />
            </div>
        </div>   
    )
}

export default ProfileRow